import createReactClass from "create-react-class";
const tools = require('form/tools')();


export default function(uniqueId = id => id) {

    return createReactClass({
        render: function() {
            var config = this.props.config;
            var state = this.props.state;
            var className = this.props.classProps;
            var pattern = tools.isNumber(config.format) ? "[0-9]*" : null;
            var type = tools.isNumber(config.format) ? "tel" : "text";

            return <input id={uniqueId(config.id)} className={className} disabled={config.disabled} type={type} onChange={this.onChange}  value={state.value} min={config.min} max={config.max} step={config.step} placeholder={config.placeholder}  />;
        },
        onChange: function(event) {
            var liveValue = event.target.value;
            this.props.state.value = liveValue;

            if (this.props.onUpdate) this.props.onUpdate();
        },
    });
};
